import React from 'react';
import { DURATION_OPTIONS, FPS_OPTIONS } from './controlConstants.js';
import { Clock, Film } from 'lucide-react';

export function DurationAndFpsSelector({
  duration,
  onSelectDuration,
  fps,
  onSelectFps
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Clock size={12} color="#c084fc" /> Duración
          </label>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
          {DURATION_OPTIONS.map((opt) => {
            const isSelected = duration === opt.id;
            return (
              <button
                key={opt.id}
                type="button"
                onClick={() => onSelectDuration(opt.id)}
                style={{
                  padding: '8px 4px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  background: isSelected ? 'rgba(168, 85, 247, 0.16)' : '#141724',
                  color: isSelected ? '#c084fc' : '#94a3b8',
                  border: isSelected ? '1px solid rgba(192, 132, 252, 0.6)' : '1px solid rgba(255,255,255,0.06)',
                  transition: 'all 0.15s ease'
                }}
              >
                <span>{opt.label}</span>
                <span style={{ fontSize: '9px', color: isSelected ? '#e9d5ff' : '#64748b' }}>{opt.sub}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Film size={12} color="#c084fc" /> Cuadros por segundo (FPS)
          </label>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
          {FPS_OPTIONS.map((opt) => {
            const isSelected = fps === opt.id;
            return (
              <button
                key={opt.id}
                type="button"
                onClick={() => onSelectFps(opt.id)}
                style={{
                  padding: '8px 4px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  background: isSelected ? 'rgba(168, 85, 247, 0.16)' : '#141724',
                  color: isSelected ? '#c084fc' : '#94a3b8',
                  border: isSelected ? '1px solid rgba(192, 132, 252, 0.6)' : '1px solid rgba(255,255,255,0.06)',
                  transition: 'all 0.15s ease'
                }}
              >
                <span>{opt.label}</span>
                <span style={{ fontSize: '9px', color: isSelected ? '#e9d5ff' : '#64748b' }}>{opt.tag}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
